<template>
	<!-- 공지사항 -->
	<sf-modal-layout size="l" :title="getMessage_('SWCC000531')" :show="opened" :closeModal="close">
		<el-row :gutter="30">
			<el-col :span="24">
				<!-- 제목 -->
				<sf-input-group :label="getMessage_('SWCC000519')" :inputValue="notiTitle" :onChange="value => onChange('notiTitle', value)" />
			</el-col>
		</el-row>
		<el-row :gutter="30">
			<el-col :span="4">
				<!-- 사용 유/무 -->
				<sf-select-group
					:label="getMessage_('SWCC000145')"
					:inputValue="useYn"
					:options="useYnOptions"
					:onChange="value => onChange('useYn', value)"
					:disabled="!notiSeq"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="30">
			<el-col :span="24">
				<!-- 내용 -->
				<sf-input-group
					:label="getMessage_('SWCC000520')"
					inputType="textarea"
					:inputValue="notiContent"
					:onChange="value => onChange('notiContent', value)"
					:elProps="{
						rows: 20,
						resize: 'none',
						maxlength: 4000,
						showWordLimit: true
					}"
				/>
			</el-col>
		</el-row>
		<template v-slot:footer>
			<!-- 닫기 -->
			<sf-button line :onClick="close">{{ getMessage_('SWCC000113') }}</sf-button>
			<!-- 수정 -->
			<sf-button v-if="notiSeq" :onClick="modifyAction">{{ getMessage_('SWCC000279') }}</sf-button>
			<!-- 등록 -->
			<sf-button v-else :onClick="registerAction">{{ getMessage_('SWCC000232') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/Notification/store/helpers';
import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			opened: false,
			notiTitle: '',
			notiContent: '',
			useYn: 'Y',
			notiSeq: ''
		};
	},

	computed: {
		...serviceComputed,
		...rootComputed,

		//유효성 검사를 위한 스키마
		schema() {
			return yup.object({
				notiTitle: yup
					.string()
					.trim()
					.default('')
					.required(
						this.$sf_formatString(this.getMessage_('SWCC000175') /**{0}은 필수 입력 항목입니다. */, [
							this.getMessage_('SWCC000519') /**제목 */
						])
					)
					.min(
						1,
						this.$sf_formatString(this.getMessage_('SWCC000176') /**{0}은 최소 {1} 자리 이상 입력해야합니다. */, [
							this.getMessage_('SWCC000519') /**제목 */,
							1
						])
					)
					.max(
						100,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000519') /**제목 */,
							100
						])
					),
				notiContent: yup
					.string()
					.trim()
					.default('')
					.required(
						this.$sf_formatString(this.getMessage_('SWCC000175') /**{0}은 필수 입력 항목입니다. */, [
							this.getMessage_('SWCC000520') /**내용 */
						])
					)
					.min(
						1,
						this.$sf_formatString(this.getMessage_('SWCC000176') /**{0}은 최소 {1} 자리 이상 입력해야합니다. */, [
							this.getMessage_('SWCC000520') /**내용 */,
							1
						])
					)
					.max(
						4000,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000520') /**내용 */
						])
					),
				useYn: yup.string().trim().default('Y')
			});
		}
	},

	watch: {
		//팝업창 opened 여부 변경시 모달 data 초기화 진행
		'notificationsModal.opened': function () {
			this.opened = this.notificationsModal.opened; //모달창 열기/닫기

			//공지사항을 선택하여 모달창을 연 경우 선택한 정보 매핑
			if (this.notificationsModal.notiSeq) {
				this.notiTitle = this.notificationsModal.notiTitle;
				this.notiContent = this.notificationsModal.notiContent;
				this.useYn = this.notificationsModal.useYn;
				this.notiSeq = this.notificationsModal.notiSeq;
			}
			//선택한 공지사항 없이 연 경우 등록을 위해 정보 초기화
			else {
				this.notiTitle = '';
				this.notiContent = '';
				this.useYn = 'Y';
				this.notiSeq = '';
			}
		}
	},

	methods: {
		...serviceMethods,
		...rootMethods,

		onChange(key, value) {
			this[key] = value;
		},

		//등록 버튼 클릭
		registerAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000501') /**저장하시겠습니까? */,
				buttons: [{ title: this.getMessage_('SWCC000232') /**등록 */, clickFn: this.register }]
			});
		},

		//수정 버튼 클릭
		modifyAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000553') /**수정하시겠습니까? */,
				buttons: [{ title: this.getMessage_('SWCC000279') /**수정 */, clickFn: this.modify }]
			});
		},

		//등록 유효성 검사 & 등록 Actipn 호출
		async register() {
			try {
				const params = { notiTitle: this.notiTitle, notiContent: this.notiContent, useYn: this.useYn };
				this.schema.validateSync(params);

				this.$sf_toggleLoading(true);
				await this.register_(params)
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});

						if (header.code === 0) {
							this.close();
						}
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		//수정 유효성 검사 & 수정 Actipn 호출
		async modify() {
			try {
				const params = { notiTitle: this.notiTitle, notiContent: this.notiContent, useYn: this.useYn, notiSeq: this.notiSeq };
				this.schema.validateSync(params);

				this.$sf_toggleLoading(true);
				await this.modify_(params)
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});

						if (header.code === 0) {
							this.close();
						}
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		//모달창 닫기
		close() {
			this.setState_({ key: 'notificationsModal', value: { opend: false } });
		}
	}
};
</script>

<style></style>
